module.exports = __webpack_public_path__ + "img/Unidad4-3.97b67d29.png";